import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { selectDataPortfolioAll } from '../../../common/filterCompany/store/slicePortfolio'
import { Element } from '../../../common/html/element'
import { Separator } from '../../../common/separator'
import {
  changeCompareLeft,
  changeCompareRight,
  selectCompareLeft,
  selectCompareRight,
  selectReportYear,
} from '../store/slice'
import { getReportYear } from '../store/thunk'
import SelectPortfolio from './SelectPortfolio'
import { filterDropList, getPortfolioLabel } from './helper'

const LeftBar = () => {
  const dispatch = useDispatch()

  const compareLeft = useSelector(selectCompareLeft)
  const compareRight = useSelector(selectCompareRight)
  const allPortfolio = useSelector(selectDataPortfolioAll)
  const reportYear = useSelector(selectReportYear)

  const [leftVal, setLeftVal] = useState(
    getPortfolioLabel(allPortfolio, compareLeft),
  )
  const [rightVal, setRightVal] = useState(
    getPortfolioLabel(allPortfolio, compareRight),
  )

  const dropListLeft = filterDropList(allPortfolio, leftVal)
  const dropListRight = filterDropList(allPortfolio, rightVal)

  const clickOutSideLeft = () => {
    const label = getPortfolioLabel(allPortfolio, compareLeft)
    setLeftVal(label)
  }

  const clickOutSideRight = () => {
    const label = getPortfolioLabel(allPortfolio, compareRight)
    setRightVal(label)
  }

  const chooseItemLeft = ({ label, value }) => {
    dispatch(changeCompareLeft(value))
    setLeftVal(value ? label : '')
  }

  const chooseItemRight = ({ label, value }) => {
    dispatch(changeCompareRight(value))
    setRightVal(value ? label : '')
  }

  useEffect(() => {
    dispatch(getReportYear())
  }, [])

  return (
    <Element className={'dFlex alignItemsCenter'}>
      <span className="fw600">
        <Translate value={'portfolio.finance.REPORT_YEAR'} />
        {reportYear}
      </span>
      <Separator
        width={1}
        height={24}
        margin={'0 12px'}
        backgroundColor="#9C9C9C"
      />
      <span className="fw600">
        <Translate value={'portfolio.finance.COMPARE_WITH'} />
      </span>
      <SelectPortfolio
        activeItem={{ value: compareLeft }}
        chooseItem={chooseItemLeft}
        data={dropListLeft}
        style={{ borderColor: '#00A8B5' }}
        handleClickOutside={clickOutSideLeft}
        inputValue={leftVal}
        onChange={setLeftVal}
      />
      <SelectPortfolio
        activeItem={{ value: compareRight }}
        chooseItem={chooseItemRight}
        data={dropListRight}
        style={{ borderColor: '#E6964C' }}
        handleClickOutside={clickOutSideRight}
        inputValue={rightVal}
        onChange={setRightVal}
      />
    </Element>
  )
}

export default LeftBar
